import { createFileRoute } from "@tanstack/react-router";
import { HubSeoContent } from "@/components/seo/HubSeoContent";
import { Blog } from "@/lib/lazyPages";
import { contentHubItemListJsonLd } from "@/lib/seo/contentHub";
import { seoHead } from "@/lib/seo/head";
import { getPublishedBlogList } from "@/lib/flywheelArticles.functions";

// /blog is the Parent Library hub; /learn 301-redirects here.
export const Route = createFileRoute("/blog/")({
  loader: async () => ({ itemList: await contentHubItemListJsonLd(), published: await getPublishedBlogList() }),
  head: ({ loaderData }) =>
    seoHead({
      title: "Parent Guides & Articles for Kids 8-14",
      description:
        "Practical guides and research-backed articles for Indian parents of kids aged 8 to 14: confidence, leadership, habits, growth mindset, screen time and more.",
      canonical: "/blog",
      jsonLd: loaderData?.itemList,
    }),
  component: BlogIndex,
});
function BlogIndex() {
  const { published } = Route.useLoaderData();
  return <><Blog published={published} /><HubSeoContent hub="blog" /></>;
}
